import { useState } from 'react';
import { generateBarcodePdf } from '../utils/barcode-pdf';

interface BarcodeExportButtonProps {
  barcodes: { value: string }[];
  bargeName: string;
  disabled?: boolean;
}

export function BarcodeExportButton({
  barcodes,
  bargeName,
  disabled = false,
}: BarcodeExportButtonProps) {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    if (barcodes.length === 0) return;

    setIsExporting(true);
    try {
      await generateBarcodePdf(barcodes, bargeName);
    } catch (error) {
      console.error('Failed to generate PDF:', error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <button
      onClick={handleExport}
      disabled={disabled || isExporting || barcodes.length === 0}
      className="px-4 py-2 bg-gray-700 hover:bg-gray-600 disabled:bg-gray-800 disabled:text-gray-500 rounded transition-colors flex items-center gap-2"
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
      {isExporting ? 'Exporting...' : 'Export Barcodes (PDF)'}
    </button>
  );
}
